import { render, staticRenderFns } from "./pay-button.vue?vue&type=template&id=75fd2d17"
import script from "./pay-button.vue?vue&type=script&lang=js"
export * from "./pay-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports